import { inject, Injectable } from '@angular/core';
import { combineLatest, Observable, switchMap, take, map, distinctUntilChanged, shareReplay } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { SendApiService } from '@vendasta/email';
import { SendPreviewService } from '@galaxy/email-ui/builder-v3';
import { AccountGroupService } from '../../account-group';
import { AuthService } from '../../auth.service';

@Injectable()
export class EmailBuilderSendPreviewService implements SendPreviewService {
  private readonly sendApiService = inject(SendApiService);
  private readonly accountGroupService = inject(AccountGroupService);
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly namespace$ = this.accountGroupService.currentAccountGroupId$;
  private readonly recipientUserId$ = toObservable(this.authService.userId);
  readonly canSendPreview$ = this.route.data.pipe(
    map((data) => data['mode']),
    map((mode) => mode === 'edit'),
    distinctUntilChanged(),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  sendPreview(contentId: string, contactId: string): Observable<string> {
    return combineLatest([this.namespace$, this.recipientUserId$]).pipe(
      take(1),
      switchMap(([namespace, recipientUserId]) =>
        this.sendApiService.sendPreviewEmailUsingEmailBuilder({
          emailBuilderEmailId: contentId,
          previewContact: {
            contactId,
            namespace,
          },
          recipient: {
            userId: recipientUserId,
          },
        }),
      ),
      map((response) => response.emailId),
    );
  }
}
